"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _draftJs = require("draft-js");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _constants = require("composer-plugins/lib/constants");

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _default = (0, _createReactClass.default)({
  displayName: "ImageComponent",
  propTypes: {
    block: _propTypes.default.object.isRequired,
    blockProps: _propTypes.default.object.isRequired,
    contentState: _propTypes.default.object.isRequired
  },
  contextTypes: {
    getEditorState: _propTypes.default.func.isRequired,
    getReadOnly: _propTypes.default.func.isRequired,
    onChange: _propTypes.default.func.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      selected: false
    };
  },
  componentDidMount: function componentDidMount() {
    var onInsertableLoaded = this.props.blockProps.onInsertableLoaded;
    document.body.addEventListener('click', this.onBodyClicked);
    _reactDom.default.findDOMNode(this._container).onload = onInsertableLoaded;
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    var getCommentsOnly = nextProps.blockProps.getCommentsOnly;
    var getReadOnly = this.context.getReadOnly;
    return !getReadOnly() && !getCommentsOnly() && nextState.selected !== this.state.selected;
  },
  componentDidUpdate: function componentDidUpdate() {
    if (this.state.selected) {
      this.forceSelectionOfImageBlock();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    document.body.removeEventListener('click', this.onBodyClicked);
  },
  onBodyClicked: function onBodyClicked(e) {
    var imageEl = _reactDom.default.findDOMNode(this._container);

    if (imageEl && (e.target === imageEl || imageEl.contains(e.target))) {
      this.toggleSelected();
    } else if (this.state.selected) {
      this.setState({
        selected: false
      });
    }
  },
  forceSelectionOfImageBlock: function forceSelectionOfImageBlock() {
    var key = this.props.block.key;
    var _this$context = this.context,
        getEditorState = _this$context.getEditorState,
        onChange = _this$context.onChange;
    window.getSelection().removeAllRanges();

    var selectionState = _draftJs.SelectionState.createEmpty(key).merge({
      anchorOffset: 1,
      focusOffset: 1
    });

    onChange(_draftJs.EditorState.forceSelection(getEditorState(), selectionState));
  },
  toggleSelected: function toggleSelected() {
    this.setState(function (prevState) {
      return {
        selected: !prevState.selected
      };
    });
  },
  render: function render() {
    var _this = this;

    var _this$props = this.props,
        block = _this$props.block,
        contentState = _this$props.contentState;
    var selected = this.state.selected;
    var key = block.getEntityAt(0);

    if (!key) {
      return null;
    }

    var _contentState$getEnti = contentState.getEntity(key).getData(),
        name = _contentState$getEnti.name,
        src = _contentState$getEnti.src;

    var classNames = (0, _classnames.default)(_constants.IMAGE_COMPONENT_CLASSNAME, {
      selected: selected
    });
    return _react.default.createElement(_UIImage.default, {
      alt: name,
      className: classNames,
      ref: function ref(c) {
        return _this._container = c;
      },
      responsive: false,
      src: src
    });
  }
});

exports.default = _default;
module.exports = exports.default;